import {authenticate} from "./OAuth-password-grant";
import {security} from "../env/Environment";

export const AuthenticationManager =  {

    login_window: null,
    windowOptions: "width=450,height=500,left=500,top=300,toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,copyhistory=yes",

    sha256( plain ) {
        const encoder = new TextEncoder();
        const data = encoder.encode(plain);
        return window.crypto.subtle.digest("SHA-256", data);
    },

    base64UrlEncode(a) {
        let str = "";
        let bytes = new Uint8Array(a);
        let len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            str += String.fromCharCode(bytes[i]);
        }
        return btoa(str)
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");
    },

    async generateCodeChallengeFromVerifier() {
        const hashed = await this.sha256(security.verifier_code);
        return this.base64UrlEncode(hashed);
    },
    async href() {
        const  code_challenge = await this.generateCodeChallengeFromVerifier();
        const url = `code_challenge_method=S256&code_challenge=${code_challenge}&client_id=${security.client_id}&redirect_uri=${this.redirectUri()}&response_type=code&scope=read`;
        return security.serverAuthorizeEndpoint + '?' + encodeURI(url);
    },

    redirectUri() {
        let host= window.location.origin;
        return host.concat("/login");
    },

    async login(){
        let url =await this.href();
        //const options = this.windowOptions.concat(",popup");
        //this.login_window = window.open(url, "_blank", options);
        this.login_window = window.open(url, "_self", this.windowOptions);
        if (!this.login_window || this.login_window.closed || typeof this.login_window.closed == 'undefined')         {
            this.login_window = window.open(url, "_blank", this.windowOptions);
        }
    },

    async authenticate(code){
        await authenticate(code ,this.redirectUri());
        if (window.opener && window.opener !== window) {
            window.close();
        }
        return true;
    },
}
